import React from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";
export const StyledInput = styled(Form.Control)`
  background-color: white !important;
  color: black !important;
  padding: 10px 10px;
  border: ${({ errorMessage, validateOnChange }) =>
    errorMessage && validateOnChange
      ? "1px solid var(--danger) !important"
      : "1px solid #e0e0e0 !important"};
  border-radius: 5px !important;
  width: 100% !important;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    border-color: var(--main-color) !important;
  }
  &:focus {
    background-color: white !important;
    border: ${({ errorMessage, validateOnChange }) =>
      errorMessage && validateOnChange
        ? "1px solid var(--danger) !important"
        : "1px solid var(--main-color) !important"};
    outline: 0;
    box-shadow: 0 0 0 3px rgba(28, 55, 65, 0.1) !important;
  }
`;
const Textarea = ({ fieldItem, validateOnChange }) => {
  const { name, textInputType, value, onChange, errorMessage, rows } =
    fieldItem;
  return (
    <>
      <StyledInput
        name={name}
        as={textInputType}
        value={value}
        onChange={onChange}
        // required={required}
        errorMessage={errorMessage}
        rows={rows}
        validateOnChange={validateOnChange}
      />
    </>
  );
};

export default Textarea;
